export default __webpack_public_path__ + "static/media/arras09.c8c8a500.jpg";